"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvironmentEditorService = exports.EnvironmentService = void 0;
const static_service_1 = require("@wix/static-service");
const services_definitions_1 = require("@wix/services-definitions");
const definition_1 = require("../definition");
const environment_1 = require("../environment");
const editorEnvironment_1 = require("../editorEnvironment");
exports.EnvironmentService = (0, static_service_1.implementStaticService)(definition_1.EnvironmentDefinition, ({ config }) => (0, environment_1.createEnvironment)(config));
exports.EnvironmentEditorService = (0, services_definitions_1.implementService)(definition_1.EnvironmentDefinition, ({ config, getService }) => (0, editorEnvironment_1.createEnvironment)(config, getService));
//# sourceMappingURL=environmentService.js.map